import script from "./Venues.vue?vue&type=script&setup=true&lang=js"
export * from "./Venues.vue?vue&type=script&setup=true&lang=js"

import "./Venues.vue?vue&type=style&index=0&id=19681813&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19681813"]])

export default __exports__